






















import Vue from 'vue'
import ProductCardGender from '@/common/components/productCard/ProductCardGender.vue'

import { formatOneDecimal } from '@/common/utils/common'
import {
  ProductState,
  ProductDetailModel,
  ProductEstimate
} from '@/product/types'

export default Vue.extend({
  components: {
    ProductCardGender
  },
  computed: {
    productDetail(): ProductDetailModel {
      return (this.$store.state as ProductState).productDetail
    },
    estimate(): ProductEstimate {
      return (this.$store.state as ProductState).estimate
    }
  },
  methods: {
    formatOneDecimal
  }
})
